export enum AnnonceTypeEnum {
  EVENT = 'EVENT',
  STRUCTURE = 'STRUCTURE',
}
